import { clearImageSasTokenCache } from "./imageSasToken";

export const SESSION_LOCAL_STORAGE_KEYS = ["user_email", "ow-signalr-outage"];
export const SESSION_SESSION_STORAGE_KEYS = ["redirectPath"];

let restartRequested = false;

const removeKeys = (getStorage, keys) => {
  keys.forEach((key) => {
    try {
      getStorage().removeItem(key);
    } catch (e) {}
  });
};

export function clearSessionTraces() {
  removeKeys(() => window.localStorage, SESSION_LOCAL_STORAGE_KEYS);
  removeKeys(() => window.sessionStorage, SESSION_SESSION_STORAGE_KEYS);
  clearImageSasTokenCache();
}

export function restartSignedOut({
  replace = (url) => window.location.replace(url),
} = {}) {
  if (restartRequested) return false;
  restartRequested = true;
  replace("/");
  return true;
}
